import { axios } from '@/utils/request'

const api = {
  businessBaseList: '/badminapi/businessbase/baseList',
  businessBaseAdd: '/badminapi/businessbase/baseadd',
  businessBaseEdit: '/badminapi/businessbase/baseEdit',
  businessBaseDelete: '/badminapi/businessbase/baseDelete',
  businessBaseDetail: '/badminapi/businessbase/baseDetail',

}

export default api

export function getBusinessBaseList(parameter) {
  return axios({
    url: api.businessBaseList,
    method: 'get',
    params: parameter
  })
}
export function getBusinessBaseDetail(parameter) {
  return axios({
    url: api.businessBaseDetail,
    method: 'get',
    params: parameter
  })
}
export function editBusinessBase(parameter) {
  return axios({
    url: api.businessBaseEdit,
    method: 'post',
    data: parameter
  })
}


export function addBusinessBase(parameter) {
  return axios({
    url: api.businessBaseAdd,
    method: 'post',
    data: parameter
  })
}
export function deleteBusinessBase(parameter) {
  return axios({
    url: api.businessBaseDelete,
    method: 'post',
    data: parameter
  })
}


